import { powerCube } from "../zhCn/rankRules";

export const goldTicketRules = `
<li>
  Gold Tickets can be voted for Characters/Stories/Games/Collections in any category (cannot be voted for one's own work), must be voted with real names, and must include a recommendation of at least 200 words in order to vote
</li>
<li>Successfully casting a Gold Ticket for the current period will earn committee members a reward of ${powerCube} 800 </li>
<li>
  Characters/Stories/Games/Collections that receive Gold Tickets will have each Gold Ticket proportionally converted into Regular Tickets and included in the current rankings
</li>
<li>
  Conversion ratio: 1 Gold Ticket = 3% of the votes received by the top-ranked work in the previous period for the same category (for the first and second period, 1 Gold Ticket = 100 Regular Tickets)
</li>
`;

export const seniorReaderRules = `
<h3>Why Apply to Become a Senior Reader?</h3>
<ol>
  <li>Upon becoming a Senior Reader, you will receive 1 "Gold Ticket" for each award period</li>
  ${goldTicketRules}
</ol>
`;

export const rankRules = `
<h2>I. Prize Mechanism</h2>
<ol>
  <li>Assessment is conducted monthly, starting on the 1st and ending on the last day of the month</li>
  <li>There are no restrictions on themes/styles for creations, but they must not be explicit or illegal</li>
  <li>
    During the award period, Characters, Stories, Games and Collections that meet the basic requirements for updates will automatically qualify for the award
  </li>
  <li>
    Reader recommendations are the sole basis for determining the award results, specifically based on the "Leaderboard" section of the Anymate platform
  </li>
  <li>Recommendation votes will be reset to zero at the end of each period and start counting anew for the next period</li>
  <li>Active readers will have more recommendation votes</li>
  <li>All voting drafts are publicly transparent and can be viewed at any time</li>
  <li>All content must have corresponding updates within this issue to be eligible for bonuses. The specific rules are as follows:
    <ul>
        <li>Games: The word count of game updates within this issue exceeds 3000 words.</li>
        <li>Stories: The word count of updates within this issue exceeds 1500 words.</li>
        <li>Characters: The number of moment within this issue exceeds 5.</li>
        <li>Collections: The number of collaborators for a collection exceeds 2, and the number of new contents within this issue exceeds 10.</li>
    </ul>
</li>

</ol>
<h2>II. Bonus</h2>
<ol>
  <li>Bonuses are awarded monthly, the top 60 in the overall ranking can win prizes (with a minimum of 10 votes required to be eligible). The specific prizes are as follows:</li>
</ol>
<blockquote>
<div>1st place: ${powerCube} 10,000</div>
<div>2nd place: ${powerCube} 8,000</div>
<div>3rd place: ${powerCube} 6,000</div>
<div>4th place: ${powerCube} 5,000</div>
<div>5th place: ${powerCube} 4,400</div>
<div>6th place: ${powerCube} 4,000</div>
<div>7th place: ${powerCube} 3,600</div>
<div>8th place: ${powerCube} 3,000</div>
<div>9th place: ${powerCube} 2,400</div>
<div>10th place: ${powerCube} 2,000</div>
<div>11th-60th place: Average distribution of ${powerCube} 63,500</div>
</blockquote>
<ol start="2">
  <li>
    Bonus payout time: 3 working days after the end of the award period (during this period, there will be ticket verification, ticket brushing checks, and investigation of reports, etc.)
  </li>
  <li>
    If problems are found during the ticket verification process, problematic works will be excluded, and works ranked behind them will be promoted accordingly
  </li>
  <li>Ties will be evenly split among tied participants</li>
</ol>
<h2>III. Anti-Vote Manipulation</h2>
<ol>
  <li>Each user is limited to 10 votes per day</li>
  <li>Anonymous votes must include a comment of at least 10 words</li>
  <li>Users identified as "suspected vote manipulators" will have their voting behavior restricted</li>
</ol>
<h2>IV. Gold Tickets</h2>
<p>We use the "Gold Ticket" mechanism to protect outstanding creators:</p>
<ol>
  <li>
    A 10-person committee composed of "Senior Readers & Platform Editorial Department", with members regularly updated to ensure flexibility. Members will be replaced at any time if they are found to be engaging in fraudulent or inactive behavior.
  </li>
  <li>
    Each committee member will have 1 "Gold Ticket" for each award period, which will be reset to zero if not used by the end of the period
  </li>
  ${goldTicketRules}
</ol>
`;
